import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import {
  LoginRes,
  RegisterUser,
  Usermodel,
} from '../Models/UserModel.interface';
import { Router } from '@angular/router';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import { DesignModel } from '../../../models/design-model';
import { CookieService } from 'ngx-cookie-service';
import { AppConstants_settings } from '../../../core/AppConstants_Appsettings.enum';
import { TenantsService } from '../../../core/services/tenants.service';
import { Store } from '@ngrx/store';
import { loadAgentList } from '../../../store/AgentlistMaster/Agentlist.action';
import { loadAirlines } from '../../../store/AirlinelistMaster/Airlinelist.action';
import { loadAirportList } from '../../../store/AirportListMaster/Airportlist.action';
import { GetBranch } from '../../../store/Branchmaster/Branchmaster.action';
import { loadChannels } from '../../../store/ChannellistMaster/Channellist.action';
import { loadCountryList } from '../../../store/CountryListMaster/Countrylist.action';
import { loadGroupList } from '../../../store/GroupMaster/Grouplist.action';
import { loadServices } from '../../../store/ServiceslistMaster/Serviceslist.action';
import { loadSuppliers } from '../../../store/SupplierlistMaster/Supplierlist.action';
import { environment } from '../../../../environments/environment';
import { StorageService } from '../../../core/services/storage-service.service';

@Injectable({
  providedIn: 'root',
})
export class NSLoginService {
  baseurl: string = AppConstants_settings.BACKOFFICE_URL;
  initialdataloaded: boolean = false;
  private tokenTimerSub: Subscription | null = null;
  isLoggedIn = computed(() => !!this.userToken());
  userToken = signal<string | null>(null);
  public RemainingTime$ = new BehaviorSubject<{
    hours: number;
    minutes: number;
  }>({ hours: 0, minutes: 0 });
  public isloading = new BehaviorSubject<boolean>(false);
  constructor(
    private httpclient: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private tenentService: TenantsService,
    private store: Store,
    private storage: StorageService
  ) { }
  gettoken() {
    let token = this.cookieService.get('authToken');
    if (token && token.length > 0) {
      this.userToken.set(token);
      return token;
    } else {
      this.userToken.set(null);
      return '';
    }
  }
  RegisterUser(model: RegisterUser): Observable<any> {
    return this.httpclient.post(this.baseurl + '/Login/RegisterUser', model);
  }
  Userlogin(usermodel: Usermodel): Observable<LoginRes> {
    return this.httpclient.post<LoginRes>(
      this.baseurl + '/Login/Loginuser',
      usermodel
    );
  }
  LoginwithToken(authToken: string): boolean {
    this.cookieService.delete('authToken', '/');
    if (authToken && authToken.length > 0) {
      this.cookieService.set('authToken', authToken, { path: '/' });
      this.startTokenTimer(authToken);
      this.userToken.set(authToken);
      this.loadinitdata();
      return true;
    }
    this.userToken.set(null);
    return false;
  }

  private startTokenTimer(token: string) {
    const expiration = this.getTokenExpiration(token);
    this.tokenTimerSub?.unsubscribe();
    this.tokenTimerSub = interval(1000).subscribe(() => {
      let now = Date.now() / 1000;
      let remainingSeconds = Math.max(0, Math.floor(expiration - now));
      let hours = Math.floor(remainingSeconds / 3600);
      let minutes = Math.floor((remainingSeconds % 3600) / 60);
      this.RemainingTime$.next({ hours, minutes });
      if (remainingSeconds <= 0) {
        this.tokenTimerSub?.unsubscribe();
        this.logout();
      }
    });
  }

  private getTokenExpiration(token: string): number {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      this.tenentService.Active_StaffId = payload?.BranchId || '1';
      environment.ActiveId = payload?.Id;
      return payload.exp; // JWT expiration time (in seconds since epoch)
    } catch (e) {
      console.log('err', e);
      return 0;
    }
  }
  logout() {
    this.storage.clearLocal();
    this.tokenTimerSub?.unsubscribe();
    this.userToken.set(null);
    this.cookieService.delete('authToken', '/');
    this.router.navigate(['/userlogin']);
  }
  //#region
  SetDesign(designmodel: DesignModel): Observable<any> {
    return this.httpclient.post<any>(
      this.baseurl + '/login/UpdateDesign',
      designmodel
    );
  }
  Getdesign() {
    return this.httpclient.get<DesignModel[]>(this.baseurl + '/login/Getdesign');
  }
  //#endregion
  loadinitdata() {
    if (!this.initialdataloaded) {
      //////////////masters loading //////////////
      this.store.dispatch(loadAirlines());
      this.store.dispatch(loadAirportList());
      this.store.dispatch(loadServices());
      this.store.dispatch(loadSuppliers());
      this.store.dispatch(loadCountryList());
      this.store.dispatch(GetBranch());
      this.store.dispatch(loadChannels());
      this.store.dispatch(loadAgentList());
      this.store.dispatch(loadGroupList());
      console.log('initdata loaded');
      this.initialdataloaded = true;
      //////////////
    }

  }
}
